// Template dependencies
import { CommonModule } from '@angular/common';
import { ElementRef } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { API_TOOLS_OPTIONS, API_V4_TOOLS_OPTIONS, FREE_TRIAL_ITEM, HEADER_MAIN_MENU_OPTIONS, PRO_ADMIN_TIER, SIGN_IN_ITEM, SUPPORT_INDICATOR_DATA_MANAGERS_OPTIONS, SUPPORT_LIST_OPTIONS, SUPPORT_SYSTEMS_OPTIONS, SUPPORT_Y_DASHBOARD_OPTIONS, TOOLS_OPTIONS, } from './constants';
import { API_FEATURE, API_V4_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { SAVED_ITEMS_ICONS_SUFFIX } from 'SearchApp/ts/constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { NavigationInternalsModule } from 'Angular/features/components/navigation/navigation-internals.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { TopBarNavAutocompleteModule } from 'SearchApp/ts/features/top-bar-nav-autocomplete/top-bar-nav-autocomplete.module';
import { TopBarNavAutocompleteComponent } from 'SearchApp/ts/features/top-bar-nav-autocomplete/top-bar-nav-autocomplete.component';
import { isDesktop as isDesktopMethod } from 'Angular/utils/media';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../directives/icon/icon.directive";
import * as i4 from "../nav-menu-list/nav-menu-list.component";
import * as i5 from "../user-menu/user-menu.component";
import * as i6 from "../../../directives/popovers/tooltip/tooltip.directive";
import * as i7 from "../../../../../../../apps/search/static/search/ts/features/top-bar-nav-autocomplete/top-bar-nav-autocomplete.component";
const _c0 = a0 => ({ "is-search-mode": a0 });
const _c1 = a0 => ({ show: a0 });
const _c2 = a0 => ({ "show": a0 });
const _c3 = a0 => ({ "is-active": a0 });
const _c4 = a0 => ({ "is-centered": a0 });
function TopBarNavComponent_ng_container_7_ycn_nav_menu_list_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-nav-menu-list", 22);
} if (rf & 2) {
    const menuItem_r1 = ctx.$implicit;
    i0.ɵɵproperty("config", menuItem_r1);
} }
function TopBarNavComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TopBarNavComponent_ng_container_7_ycn_nav_menu_list_1_Template, 1, 1, "ycn-nav-menu-list", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.headerMainMenuConfig);
} }
function TopBarNavComponent_ycn_top_bar_nav_autocomplete_9_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-top-bar-nav-autocomplete", 23);
    i0.ɵɵlistener("click", function TopBarNavComponent_ycn_top_bar_nav_autocomplete_9_Template_ycn_top_bar_nav_autocomplete_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.searchActiveOn()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c4, ctx_r1.isDesktop))("defaultResults", ctx_r1.defaultResults);
} }
function TopBarNavComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function TopBarNavComponent_button_13_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.scheduleDemo($event)); });
    i0.ɵɵelement(1, "span", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r1.scheduleDemoText);
} }
function TopBarNavComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26)(1, "span", 27);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 28)(4, "div", 29);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.USER.daysRemainingInTrial, " Days Remaining ");
    i0.ɵɵadvance(2);
    i0.ɵɵstyleMap(i0.ɵɵinterpolate1("--trialDaysRemaining: ", ctx_r1.USER.daysRemainingInTrial, "; --trialDaysTotal: 7"));
    i0.ɵɵproperty("tooltipTitle", ctx_r1.USER.daysRemainingInTrial + " Days Remaining");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.USER.daysRemainingInTrial);
} }
function TopBarNavComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "a", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.FREE_TRIAL_ITEM.itemClass);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.FREE_TRIAL_ITEM.linkClass);
    i0.ɵɵproperty("href", ctx_r1.FREE_TRIAL_ITEM.href, i0.ɵɵsanitizeUrl)("textContent", ctx_r1.FREE_TRIAL_ITEM.text);
} }
function TopBarNavComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31)(1, "div", 32);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 33);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵproperty("tooltipTitle", "Chat with us");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-chat");
} }
function TopBarNavComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34)(1, "div", 35)(2, "div", 36);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 33);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    i0.ɵɵproperty("tooltipTitle", "Resource Center");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-pendo");
} }
function TopBarNavComponent_ng_container_18_ycn_nav_menu_list_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-nav-menu-list", 22);
} if (rf & 2) {
    const menuItem_r5 = ctx.$implicit;
    i0.ɵɵproperty("config", menuItem_r5);
} }
function TopBarNavComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 37)(2, "span", 38);
    i0.ɵɵtext(3, " SALES (866) 965-7552 ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 39);
    i0.ɵɵtemplate(5, TopBarNavComponent_ng_container_18_ycn_nav_menu_list_5_Template, 1, 1, "ycn-nav-menu-list", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r1.headerMainMenuConfig);
} }
function TopBarNavComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "a", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.SIGN_IN_ITEM.itemClass);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.SIGN_IN_ITEM.linkClass);
    i0.ɵɵproperty("href", ctx_r1.nextLoginLink, i0.ɵɵsanitizeUrl)("textContent", ctx_r1.SIGN_IN_ITEM.text);
} }
function TopBarNavComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵlistener("mouseenter", function TopBarNavComponent_div_20_Template_div_mouseenter_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setUserMenuActive(true)); })("mouseleave", function TopBarNavComponent_div_20_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setUserMenuActive(false)); });
    i0.ɵɵelementStart(1, "div", 41)(2, "div", 42);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 33);
    i0.ɵɵelement(4, "use", 43);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(5, "div", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ycn-user-menu", 45);
    i0.ɵɵlistener("addErrorMessageHandler", function TopBarNavComponent_div_20_Template_ycn_user_menu_addErrorMessageHandler_6_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.addErrorMessage($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3, ctx_r1.userMenuActive));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-user");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r1.formattedUserText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("userMenuActive", ctx_r1.userMenuActive);
} }
function TopBarNavComponent_For_27_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 46)(2, "div", 47);
    i0.ɵɵelement(3, "div", 48);
    i0.ɵɵelementStart(4, "div", 49)(5, "div", 50);
    i0.ɵɵlistener("click", function TopBarNavComponent_For_27_Template_div_click_5_listener() { const $index_r8 = i0.ɵɵrestoreView(_r7).$index; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.removeErrorMessage($index_r8)); });
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(7, "svg", 33);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const message_r9 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", message_r9, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("name", "icon-close");
} }
/**
 *
 * Top Bar Nav Component
 *
 * Highest level component for our top navigation bar.
 *
 */
export class TopBarNavComponent {
    constructor(eltRef, featureService) {
        this.eltRef = eltRef;
        this.featureService = featureService;
        this.USER = window.USER;
        this.formattedUserText = window.USER.firstName ?? window.USER.email;
        this.scheduleDemoText = HEADER_MAIN_MENU_OPTIONS.SCHEDULE_DEMO.title;
        this.errorMessages = [];
        // header config
        this.headerMainMenuConfig = [];
        // menu options
        this.FREE_TRIAL_ITEM = FREE_TRIAL_ITEM;
        this.SIGN_IN_ITEM = SIGN_IN_ITEM;
        // booleans
        this.chatEnabled = false;
        this.mainMenuActive = false;
        this.searchActive = false;
        this.searchMenuActive = false;
        this.userMenuActive = false;
        this.isDesktop = false;
        this.contentLinks = [];
        this.defaultResults = [];
        this.showTrial = (this.USER.authenticated && !this.USER.hasUpgraded) || !this.USER.authenticated;
        this.nextLoginLink = `/login?next=${window.location.pathname}`;
        this.totalLockout = this.eltRef.nativeElement.getAttribute('totalLockout') || false;
        this.overrideHeaderConfig = JSON.parse(this.eltRef.nativeElement.getAttribute('overrideHeaderConfig')) || [];
        const headerContent = JSON.parse(eltRef.nativeElement.getAttribute('headerContent')) || {};
        this.contentLinks = headerContent.support_content || [];
        const userLastSavedItems = (headerContent.user_last_saved_items || []).map(({ url, name, type, features_needed }) => ({
            label: name,
            url,
            icon: `file-${SAVED_ITEMS_ICONS_SUFFIX[type]}`,
            features_needed,
            suffix: SAVED_ITEMS_ICONS_SUFFIX[type],
            type: 'asset',
        }));
        const userVisitedSecurities = (headerContent.last_visited_securities || []).map(({ url, name, features_needed, display_security_id }) => ({
            label: display_security_id,
            url,
            features_needed,
            description: name,
            type: 'security',
        }));
        this.defaultResults = [...userVisitedSecurities, ...userLastSavedItems];
    }
    ngOnInit() {
        this.addWidthAsBodyStyle();
        // Before loading remove the preloaded header placeholder.
        const placeholder = document.getElementById('header-placeholder');
        if (placeholder && placeholder.parentNode) {
            // Call `removeChild()` since IE does not support `remove()`.
            placeholder.parentNode.removeChild(placeholder);
        }
        this.headerMainMenuConfig = this.getHeaderMainMenuConfig();
        // Other components that show a button that opens HubSpot chat (for example SupportContactInfoPageComponent)
        // cannot rely on hsConversationsOnReady to determine when the chat is ready, because
        // the component may be loaded after functions in the hsConversationsOnReady array have already been executed.
        // TopBarNavComponent loads before other components, so it's not an issue here.
        // Functions in hsConversationsOnReady are only executed once, so other components besides TopBarNavComponent need this
        // subject to know whether functions in hsConversationsOnReady have been executed as a way to determine whether the chat
        // button should be shown.
        window.hsChatEnabledSubject = new ReplaySubject();
        // The window.hsConversationsOnReady is not always present on load since not
        // all users have access to our chat (i.e. Students or Users who have has_chat set
        // to False). If the hsConversationsOnReady array is available we know we can add a
        // callback function to show the chat.
        // it is possible that the ready event has already been fired, if the HubSpotConversations
        // object is set then we know hsConversationsOnReady already happened
        const enableChat = () => {
            this.chatEnabled = true;
            window.hsChatEnabledSubject.next();
        };
        if (window.HubSpotConversations) {
            enableChat();
        }
        else if (window.hsConversationsOnReady !== undefined) {
            window.hsConversationsOnReady.push(enableChat);
        }
        // open menu by default if user on PRO_ADMIN tier (impersonation only)
        this.userMenuActive = this.USER.tierInternalName === PRO_ADMIN_TIER;
    }
    getHeaderMainMenuConfig() {
        /**
         * Dynamically sets the content of the navigation menu, depending on properties of USER such as:
         *  - their features
         *  - their missing feature view preference
         *  - the groups they belong to
         *  - whether they are authenticated
         *  - whether they have upgraded or are on a free trial
         *  - Their content links
         */
        // Set the dropdown for the Data tab
        const headerDataMenu = { ...HEADER_MAIN_MENU_OPTIONS.DATA };
        headerDataMenu.columns = this.addLockToMenuItems(this.filterHiddenMenuItems(HEADER_MAIN_MENU_OPTIONS.DATA.columns));
        headerDataMenu.content = this.contentLinks.find((item) => item.tab.toUpperCase() === 'DATA');
        // Set the columns for the Tools tab
        const toolsListColumns = this.addLockToMenuItems(this.filterHiddenMenuItems(TOOLS_OPTIONS));
        if (this.featureService.userHasFeatures([API_FEATURE])) {
            toolsListColumns[toolsListColumns.length - 1].list.push(...API_TOOLS_OPTIONS);
            if (this.featureService.userHasFeatures([API_V4_FEATURE])) {
                // Both API versions tool options include a divider. If both are shown, don't push the second divider.
                toolsListColumns[toolsListColumns.length - 1].list.push(API_V4_TOOLS_OPTIONS[1]);
            }
        }
        else if (this.featureService.userHasFeatures([API_V4_FEATURE])) {
            toolsListColumns[toolsListColumns.length - 1].list.push(...API_V4_TOOLS_OPTIONS);
        }
        const headerToolsMenu = Object.assign([], HEADER_MAIN_MENU_OPTIONS.TOOLS);
        headerToolsMenu.columns = toolsListColumns;
        headerToolsMenu.content = this.contentLinks.find((item) => item.tab.toUpperCase() === 'TOOLS');
        // Set the dropdown for the Support tab
        let supportListOptions = Object.assign([], SUPPORT_LIST_OPTIONS);
        supportListOptions = this.addLockToMenuItems(this.filterHiddenMenuItems(supportListOptions));
        if (this.USER.groups.includes('systems')) {
            supportListOptions[supportListOptions.length - 1].list.push(...SUPPORT_SYSTEMS_OPTIONS);
        }
        if (this.USER.groups.includes('indicator_data_managers')) {
            supportListOptions[supportListOptions.length - 1].list.push(...SUPPORT_INDICATOR_DATA_MANAGERS_OPTIONS);
        }
        if (this.USER.groups.includes('y_dashboard')) {
            supportListOptions[supportListOptions.length - 1].list.push(...SUPPORT_Y_DASHBOARD_OPTIONS);
        }
        const headerSupportMenu = { ...HEADER_MAIN_MENU_OPTIONS.SUPPORT };
        headerSupportMenu.columns = supportListOptions;
        headerSupportMenu.content = this.contentLinks.find((item) => item.tab.toUpperCase() === 'SUPPORT');
        // Set the main menu config using the three dropdowns
        let headerMainMenuConfig = [headerDataMenu, headerToolsMenu, headerSupportMenu];
        // Add Plans / Free Trial links if necessary
        if (this.overrideHeaderConfig.length > 0) {
            headerMainMenuConfig = [];
            this.overrideHeaderConfig.forEach((itemName) => {
                if (itemName === 'TOOLS') {
                    headerMainMenuConfig.push(headerToolsMenu);
                }
                else if (itemName === 'SUPPORT') {
                    headerMainMenuConfig.push(headerSupportMenu);
                }
                else if (itemName === 'DATA') {
                    headerMainMenuConfig.push(headerDataMenu);
                }
                else {
                    headerMainMenuConfig.push(HEADER_MAIN_MENU_OPTIONS[itemName]);
                }
            });
        }
        else if (this.USER.authenticated && !this.USER.hasUpgraded) {
            headerMainMenuConfig.push(HEADER_MAIN_MENU_OPTIONS.TRIAL_WALL);
            headerMainMenuConfig.push(HEADER_MAIN_MENU_OPTIONS.FREE_TRIAL);
            // authenticated but days remaining in trial, link to plans
        }
        else if (this.USER.authenticated && !!this.USER.daysRemainingInTrial) {
            headerMainMenuConfig.push(HEADER_MAIN_MENU_OPTIONS.TRIAL_WALL);
            // Not authenticated, link to plans / trial / sign in
        }
        else if (!this.USER.authenticated) {
            headerMainMenuConfig.push(HEADER_MAIN_MENU_OPTIONS.PLANS);
            // Set ?next= path for SIGN_IN href
        }
        return headerMainMenuConfig;
    }
    toggleMainMenuActive() {
        this.mainMenuActive = !this.mainMenuActive;
        this.searchMenuActive = false;
        this.userMenuActive = false;
    }
    setUserMenuActive(active) {
        this.userMenuActive = active;
        this.mainMenuActive = false;
        this.searchActive = false;
    }
    searchActiveOn() {
        this.searchActive = true;
    }
    searchActiveOff() {
        this.searchActive = false;
        this.topBarNavAutocomplete.reset();
    }
    scheduleDemo(e) {
        const demoUrl = `${HEADER_MAIN_MENU_OPTIONS.SCHEDULE_DEMO.href}?id=${this.USER.email}`;
        window.open(demoUrl, '_blank');
        e.preventDefault();
    }
    addLockToMenuItems(menuColumns) {
        return menuColumns.map((column) => ({
            ...column,
            list: column.list.map((menuItem) => {
                const featuresRequired = menuItem.features || [];
                const hasFeatures = menuItem.someFeatures
                    ? this.featureService.userHasSomeFeatures(featuresRequired)
                    : this.featureService.userHasFeatures(featuresRequired);
                const missingFeaturePreference = menuItem.overrideMissingFeaturePreference || this.USER.missingFeaturePreference;
                return {
                    ...menuItem,
                    showLock: menuItem.type !== 'divider' && !hasFeatures && missingFeaturePreference === 'upsell',
                };
            }),
        }));
    }
    /**
     * Filters out menu items that the user does not have access to if the user has hide as their missing feature view
     * preference.
     */
    filterHiddenMenuItems(menuColumns) {
        if (this.featureService.allFeaturesAvailable) {
            return menuColumns;
        }
        return menuColumns
            .filter((column) => {
            const columnFeatures = column.features || [];
            return this.featureService.userHasFeatures(columnFeatures);
        })
            .map((column) => {
            let lastPushWasDivider = false;
            return {
                ...column,
                list: column.list.filter((menuItem) => {
                    const featuresRequired = menuItem.features || [];
                    const isDivider = menuItem.type === 'divider';
                    const hasFeatures = menuItem.someFeatures
                        ? this.featureService.userHasSomeFeatures(featuresRequired)
                        : this.featureService.userHasFeatures(featuresRequired);
                    const missingFeaturePreference = menuItem.overrideMissingFeaturePreference || this.USER.missingFeaturePreference;
                    const showFeature = hasFeatures || missingFeaturePreference !== 'hide';
                    const includeItem = (isDivider && !lastPushWasDivider) || (!isDivider && showFeature);
                    lastPushWasDivider = isDivider;
                    return includeItem;
                }),
            };
        })
            .filter((column) => column.list.length > 0);
    }
    updateLegendPosition() {
        this.isDesktop = isDesktopMethod();
        this.addWidthAsBodyStyle();
    }
    /**
     * There is a --body-width CSS variable that needs this
     */
    addWidthAsBodyStyle() {
        const body = document.querySelector('body');
        if (body) {
            body.style.setProperty('--body-width', `${body.clientWidth}px`);
        }
    }
    addErrorMessage(message) {
        this.errorMessages.push(message);
    }
    removeErrorMessage(index) {
        this.errorMessages.splice(index, 1);
    }
}
TopBarNavComponent.ɵfac = function TopBarNavComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TopBarNavComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.FeatureService)); };
TopBarNavComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TopBarNavComponent, selectors: [["ycn-top-bar-nav"]], viewQuery: function TopBarNavComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(TopBarNavAutocompleteComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.topBarNavAutocomplete = _t.first);
    } }, hostBindings: function TopBarNavComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function TopBarNavComponent_resize_HostBindingHandler($event) { return ctx.updateLegendPosition($event); }, i0.ɵɵresolveWindow);
    } }, decls: 28, vars: 23, consts: [[1, "header", 3, "ngClass"], [1, "header-container", "container", "user-select-none"], [1, "header-logo-wrap"], [1, "header-logo", 3, "href"], ["alt", "YCharts logo", "src", "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='155px' height='21px' viewBox='-0.195 0 155 21' enable-background='new -0.195 0 155 21' xml:space='preserve'%3E%3Cpolygon fill='%230282E8' points='14.863,0.358 7.823,12.352 7.823,20.428 12.214,20.428 12.214,12.614 19.939,0.358 '/%3E%3Cpolygon fill='%230282E8' points='8.034,5.392 5.044,0.358 -0.195,0.358 5.697,9.646 '/%3E%3Cpath fill='%23FFFFFF' d='M32.348,21c-5.975,0-10.413-4.609-10.413-10.441V10.5c0-5.77,4.354-10.5,10.588-10.5 c3.831,0,6.121,1.278,8.008,3.133l-2.845,3.279c-1.565-1.422-3.16-2.292-5.189-2.292c-3.423,0-5.888,2.843-5.888,6.323V10.5 c0,3.48,2.406,6.382,5.888,6.382c2.32,0,3.742-0.929,5.336-2.377l2.844,2.872C38.587,19.607,36.264,21,32.348,21'/%3E%3Cpolygon fill='%23FFFFFF' points='59.338,20.65 59.338,12.502 51.1,12.502 51.1,20.65 46.633,20.65 46.633,0.35 51.1,0.35 51.1,8.383 59.338,8.383 59.338,0.35 63.805,0.35 63.805,20.65 '/%3E%3Cpath fill='%23FFFFFF' d='M79.625,5.57l-2.694,6.584h5.39L79.625,5.57z M85.772,20.65l-1.854-4.553h-8.585l-1.858,4.553h-4.553 l8.699-20.446h4.119L90.44,20.65H85.772z'/%3E%3Cpath fill='%23FFFFFF' d='M107.926,7.281c0-1.914-1.333-2.901-3.511-2.901h-4.438v5.829h4.523c2.177,0,3.423-1.161,3.423-2.872 L107.926,7.281L107.926,7.281z M107.839,20.65l-4.353-6.496h-3.511v6.496H95.51V0.35h9.28c4.788,0,7.656,2.523,7.656,6.7v0.06 c0,3.276-1.771,5.335-4.352,6.294l4.96,7.25h-5.223V20.65H107.839z'/%3E%3Cpolygon fill='%23FFFFFF' points='128.369,4.467 128.369,20.65 123.903,20.65 123.903,4.467 117.723,4.467 117.723,0.35 134.548,0.35 134.548,4.467 '/%3E%3Cpath fill='%23FFFFFF' d='M146.962,20.941c-3.074,0-6.18-1.073-8.612-3.248l2.642-3.161c1.823,1.509,3.74,2.465,6.062,2.465 c1.828,0,2.932-0.726,2.932-1.915v-0.059c0-1.131-0.696-1.713-4.09-2.582c-4.091-1.043-6.729-2.173-6.729-6.207V6.179 c0-3.682,2.957-6.12,7.103-6.12c2.963,0,5.481,0.927,7.543,2.579l-2.318,3.366c-1.804-1.248-3.567-2-5.277-2 c-1.714,0-2.612,0.782-2.612,1.769v0.059c0,1.333,0.871,1.77,4.379,2.668c4.119,1.074,6.44,2.553,6.44,6.092v0.061 C154.417,18.682,151.344,20.941,146.962,20.941'/%3E%3C/svg%3E", 1, "visible-lg-block"], ["alt", "YCharts logo", "src", "data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M15.7752 0.462769L8.39917 13.0298V21.4898H12.9982V13.3038L21.0942 0.462769H15.7752Z' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 0.462769L6.172 10.1938L8.619 5.73777L5.487 0.462769H0Z' fill='white'/%3E%3C/svg%3E", 1, "hidden-lg"], [1, "header-mainmenu", "user-select-none", 3, "ngClass"], [4, "ngIf"], [1, "header-search"], ["class", "field-input-group input-group dropdown show field-search compact", 3, "ngClass", "defaultResults", "click", 4, "ngIf"], [1, "header-search-close", 3, "click", "ngClass"], [1, "header-sidemenu", "user-select-none"], ["class", "header-button btn btn-primary align-self-center", 3, "click", 4, "ngIf"], ["class", "sidemenu-item header-message", 4, "ngIf"], [3, "class", 4, "ngIf"], ["class", "sidemenu-item sidemenu-item-chat", "onclick", "window.openHubSpotChat();", "ycnTooltip", "", 3, "tooltipTitle", 4, "ngIf"], ["class", "sidemenu-item sidemenu-item-pendo", "ycnTooltip", "", 3, "tooltipTitle", 4, "ngIf"], ["class", "sidemenu-item sidemenu-item-usermenu-toggler header-usermenu dropdown pendo-manage-account", "data-test-id", "user-menu-toggle", 3, "ngClass", "mouseenter", "mouseleave", 4, "ngIf"], [1, "header-toggler"], [1, "header-mainmenu-toggler-button", 3, "click", "ngClass"], [1, "line"], ["class", "header-mainmenu-item", 3, "config", 4, "ngFor", "ngForOf"], [1, "header-mainmenu-item", 3, "config"], [1, "field-input-group", "input-group", "dropdown", "show", "field-search", "compact", 3, "click", "ngClass", "defaultResults"], [1, "header-button", "btn", "btn-primary", "align-self-center", 3, "click"], [1, "text-small", "text-nowrap", 3, "textContent"], [1, "sidemenu-item", "header-message"], [1, "text-green", "align-items-center", "visible-xl-flex"], [1, "d-flex", "align-items-center"], ["ycnTooltip", "", 1, "circle-stats", "text-green", "hidden-xl", 3, "tooltipTitle"], [3, "href", "textContent"], ["onclick", "window.openHubSpotChat();", "ycnTooltip", "", 1, "sidemenu-item", "sidemenu-item-chat", 3, "tooltipTitle"], [1, "sidemenu-icon", "text-green"], ["ycnIcon", "", 3, "name"], ["ycnTooltip", "", 1, "sidemenu-item", "sidemenu-item-pendo", 3, "tooltipTitle"], [1, "pendo-widget"], [1, "sidemenu-icon", "pendo-widget-icon"], [1, "header-sidemenu-item", "visible-lg-flex"], [2, "color", "#ffce00", "font-weight", "700", "align-self", "center"], [1, "header-mainmenu", "user-select-none"], ["data-test-id", "user-menu-toggle", 1, "sidemenu-item", "sidemenu-item-usermenu-toggler", "header-usermenu", "dropdown", "pendo-manage-account", 3, "mouseenter", "mouseleave", "ngClass"], [1, "header-usermenu-toggler-wrap"], [1, "sidemenu-icon"], [0, "xlink", "href", "#icon-user"], [1, "user-name", "visible-xl-block", 3, "textContent"], [3, "addErrorMessageHandler", "userMenuActive"], [1, "page-message", "page-message-error"], [1, "container"], [1, "page-message-text", 3, "innerHTML"], [1, "page-message-actions"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"]], template: function TopBarNavComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "header", 0)(1, "div", 1)(2, "div", 2)(3, "a", 3);
        i0.ɵɵelement(4, "img", 4)(5, "img", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵtemplate(7, TopBarNavComponent_ng_container_7_Template, 2, 1, "ng-container", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵtemplate(9, TopBarNavComponent_ycn_top_bar_nav_autocomplete_9_Template, 1, 4, "ycn-top-bar-nav-autocomplete", 9);
        i0.ɵɵelementStart(10, "div", 10);
        i0.ɵɵlistener("click", function TopBarNavComponent_Template_div_click_10_listener() { return ctx.searchActiveOff(); });
        i0.ɵɵtext(11, " Cancel ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "div", 11);
        i0.ɵɵtemplate(13, TopBarNavComponent_button_13_Template, 2, 1, "button", 12)(14, TopBarNavComponent_div_14_Template, 6, 6, "div", 13)(15, TopBarNavComponent_div_15_Template, 2, 6, "div", 14)(16, TopBarNavComponent_div_16_Template, 3, 2, "div", 15)(17, TopBarNavComponent_div_17_Template, 4, 2, "div", 16)(18, TopBarNavComponent_ng_container_18_Template, 6, 1, "ng-container", 7)(19, TopBarNavComponent_div_19_Template, 2, 6, "div", 14)(20, TopBarNavComponent_div_20_Template, 7, 6, "div", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 18)(22, "div", 19);
        i0.ɵɵlistener("click", function TopBarNavComponent_Template_div_click_22_listener() { return ctx.toggleMainMenuActive(); });
        i0.ɵɵelement(23, "span", 20)(24, "span", 20)(25, "span", 20);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵrepeaterCreate(26, TopBarNavComponent_For_27_Template, 8, 2, "ng-container", null, i0.ɵɵrepeaterTrackByIndex);
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c0, ctx.searchActive));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("href", "/", i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c1, ctx.mainMenuActive));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.totalLockout);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.totalLockout);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c2, ctx.searchActive));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.USER.unpaidTrial);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !!ctx.USER.daysRemainingInTrial);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showTrial && !ctx.totalLockout);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.chatEnabled);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.USER.authenticated && !ctx.totalLockout);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.totalLockout);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.USER.authenticated);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.USER.authenticated);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c3, ctx.mainMenuActive));
        i0.ɵɵadvance(4);
        i0.ɵɵrepeater(ctx.errorMessages);
    } }, dependencies: [CommonModule, i2.NgClass, i2.NgForOf, i2.NgIf, IconModule, i3.IconDirective, NavigationInternalsModule, i4.NavMenuListComponent, i5.UserMenuComponent, TooltipModule, i6.TooltipDirective, TopBarNavAutocompleteModule, i7.TopBarNavAutocompleteComponent], encapsulation: 2 });
